import React from 'react'
import { BotAvatarProps } from './BotAvatar.types'

export const BotAvatar = ({
  className = '',
  pathClassName = '',
  ...rest
}: BotAvatarProps) => (
  <svg
    className={`shrink-0 ${className}`}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-logo ${pathClassName}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 7.87398C18.7252 7.42994 20 5.86384 20 4C20 1.79086 18.2091 0 16 0C13.7909 0 12 1.79086 12 4C12 5.86384 13.2748 7.42994 15 7.87398V12H4C1.79086 12 0 13.7909 0 16L0 28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V16C32 13.7909 30.2091 12 28 12H17V7.87398ZM12 22C12 24.2091 10.2091 26 8 26C5.79086 26 4 24.2091 4 22C4 19.7909 5.79086 18 8 18C10.2091 18 12 19.7909 12 22ZM24 26C26.2091 26 28 24.2091 28 22C28 19.7909 26.2091 18 24 18C21.7909 18 20 19.7909 20 22C20 24.2091 21.7909 26 24 26Z"
    />
  </svg>
)

export default BotAvatar
